export default __webpack_public_path__ + "static/media/unsplash_50GSjnC7qXw.b0cbaf18.png";